import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['stateFrame']

  updateStates(event) {
    if (!this.hasStateFrameTarget) return

    const countryCode = event.target.value

    const url = new URL('/users/states_for_country', window.location.origin)
    if (countryCode) url.searchParams.set('country_code', countryCode)

    this.stateFrameTarget.src = url.toString()
  }
}
